export default __webpack_public_path__ + "static/media/shopping_cart.cbc23af2.svg";